var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgObjects = function SvgObjects(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#7A7359",
    strokeLinecap: "round",
    d: "M15 14.986c0-.179.096-.342.246-.44a6 6 0 1 0-6.492 0c.15.098.246.261.246.44V19.5a1 1 0 0 0 1 1h4a1 1 0 0 0 1-1z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#7A7359",
    d: "M9 16.5h6m-6 2h6"
  })));
};
export { SvgObjects as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIGZpbGw9Im5vbmUiPjxwYXRoIHN0cm9rZT0iIzdBNzM1OSIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBkPSJNMTUgMTQuOTg2YzAtLjE3OS4wOTYtLjM0Mi4yNDYtLjQ0YTYgNiAwIDEgMC02LjQ5MiAwYy4xNS4wOTguMjQ2LjI2MS4yNDYuNDRWMTkuNWExIDEgMCAwIDAgMSAxaDRhMSAxIDAgMCAwIDEtMXYtNC41MTRaIi8+PHBhdGggc3Ryb2tlPSIjN0E3MzU5IiBkPSJNOSAxNi41aDZNOSAxOC41aDYiLz48L3N2Zz4=";